import { render, staticRenderFns } from "./origin-table-input-vue-simple-list.vue?vue&type=template&id=3ab88fee&"
import script from "./origin-table-input-vue-simple-list.vue?vue&type=script&lang=js&"
export * from "./origin-table-input-vue-simple-list.vue?vue&type=script&lang=js&"
import style0 from "./origin-table-input-vue-simple-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports